<script>
import { mapGetters } from 'vuex';
import BettingPromotionsCard from './BettingPromotionsCard.vue';
import BettingPromotionsTermsModal from './BettingPromotionsTermsModal.vue';
import ClickOutside from 'vue-click-outside';
export default {
  name: 'BettingPromotionsList',
  directives: {
    ClickOutside,
  },
  components: {
    BettingPromotionsCard,
    BettingPromotionsTermsModal,
  },
  props: {
    promos: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      bettingPromotionsList: 'BettingPromotions/getBettingPromotionsList',
      tcsModalActive: 'BettingPromotions/getTCsModalStatus',
      tcsText: 'BettingPromotions/getTCsModalText',
    }),
    // order promos by date
    orderedPromoList() {
      const { bettingPromotionsList } = this;
      return bettingPromotionsList.length > 0
        ? bettingPromotionsList.sort((a, b) => new Date(a.meetingDate) - new Date(b.meetingDate))
        : [];
    },
  },
  mounted() {
    const { promos } = this;
    if (promos.length === 0) {
      // fetch betting promotions list
      this.$store.dispatch('BettingPromotions/fetchPromotionsList');
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch('BettingPromotions/toggleModalStatus', { isActive: false, text: '' });
    },
  },
};
</script>

<template>
  <div class="betting-promotions__container">
    <div class="betting-promotions-list">
      <template v-for="(promotion, index) in orderedPromoList">
        <BettingPromotionsCard :promotion="promotion" :key="`betting-promo-card-${index}`" />
      </template>
    </div>

    <template v-if="tcsModalActive">
      <div class="betting-promotions__tcs-modal-mask">
        <div class="betting-promotions__tcs-modal-container">
          <BettingPromotionsTermsModal v-click-outside="closeModal" :terms-text="tcsText" />
        </div>
      </div>
    </template>
  </div>
</template>
